/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ColumnSettingScopeConstants } from './ColumnSettingScopeConstants';
import {
    ColumnSettingScopeConstantsFromJSON,
    ColumnSettingScopeConstantsFromJSONTyped,
    ColumnSettingScopeConstantsToJSON,
} from './ColumnSettingScopeConstants';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface ColumnSettings
 */
export interface ColumnSettings {
    /**
     * 
     * @type {Command}
     * @memberof ColumnSettings
     */
    resetColumnSettingsCommand?: Command;
    /**
     * 
     * @type {ColumnSettingScopeConstants}
     * @memberof ColumnSettings
     */
    resetScope?: ColumnSettingScopeConstants;
    /**
     * 
     * @type {Command}
     * @memberof ColumnSettings
     */
    updateCommand?: Command;
}

/**
 * Check if a given object implements the ColumnSettings interface.
 */
export function instanceOfColumnSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ColumnSettingsFromJSON(json: any): ColumnSettings {
    return ColumnSettingsFromJSONTyped(json, false);
}

export function ColumnSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resetColumnSettingsCommand': !exists(json, 'resetColumnSettingsCommand') ? undefined : CommandFromJSON(json['resetColumnSettingsCommand']),
        'resetScope': !exists(json, 'resetScope') ? undefined : ColumnSettingScopeConstantsFromJSON(json['resetScope']),
        'updateCommand': !exists(json, 'updateCommand') ? undefined : CommandFromJSON(json['updateCommand']),
    };
}

export function ColumnSettingsToJSON(value?: ColumnSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resetColumnSettingsCommand': CommandToJSON(value.resetColumnSettingsCommand),
        'resetScope': ColumnSettingScopeConstantsToJSON(value.resetScope),
        'updateCommand': CommandToJSON(value.updateCommand),
    };
}

